import { Icon, Menu, MenuButtonTrigger, MenuItemButton } from "@amzn/storm-ui";
import { useState, type ReactElement } from "react";
import styled from "styled-components";
import { useStore } from "zustand";

import { discoveryFilterStore } from "../../../store/filters";
import type {
    DiscoveryFilterField,
    DiscoveryFilter,
} from "../../../types/filters/common";

const StyledTrigger = styled(MenuButtonTrigger)`
    background: transparent;
    box-shadow: none;
    &:hover {
        background: transparent;
        box-shadow: none;
    }
`;

const StyledIcon = styled(Icon)`
    margin-right: 4px;
`;

interface Props {
    options: DiscoveryFilter[];
    selectedValues: DiscoveryFilterField[];
}

const AdditionalFilters = ({
    options,
    selectedValues,
}: Props): ReactElement => {
    const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);

    const [addFilter, removeFilter] = useStore(
        discoveryFilterStore,
        (state) => [state.addFilter, state.removeFilter],
    );

    const closeMenu = (): void => {
        setIsMenuOpen(false);
    };

    const onMenuItemClick = (
        option: DiscoveryFilter,
        isSelected: boolean,
    ): void => {
        isSelected ? removeFilter(option) : addFilter(option);
        closeMenu();
    };

    const toggleMenu = (): void => {
        setIsMenuOpen(!isMenuOpen);
    };

    return (
        <>
            <Menu
                id="additional-filters-menu"
                data-testid="additional-filters-menu"
                onClick={toggleMenu}
                onClose={closeMenu}
                isOpen={isMenuOpen}
                disabled={!options.length}
                trigger={
                    <StyledTrigger data-testid="additional-filters-button">
                        Add filters
                    </StyledTrigger>
                }
            >
                {options.map((option: DiscoveryFilter) => {
                    const isSelected = selectedValues.includes(option.field);
                    return (
                        <MenuItemButton
                            key={option.label}
                            data-testid={`${option.label}-option`}
                            onClick={() => onMenuItemClick(option, isSelected)}
                        >
                            {isSelected && <StyledIcon type="check" />}
                            {option.label}
                        </MenuItemButton>
                    );
                })}
            </Menu>
        </>
    );
};

export default AdditionalFilters;
